import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import flexible from '@/utils/flexible.js';
import childExhibitionItem from '@/components/childExhibitionItem';
import guideBottom from '@/components/guideBottom.vue';
export default {
  name: 'childExhibitions',
  data() {
    return {
      bannersList: [],
      detail: {},
      //展览详情
      formData: {},
      exhibCode: '',
      isFolded: true,
      audioList: [],
      exhibName: '',
      language: '',
      childExhibitions: []
    };
  },
  components: {
    childExhibitionItem,
    guideBottom
  },
  methods: {
    getType(type) {
      return type == '常设展览' ? 'permanent' : 'temporary';
    },
    getIdDetail() {
      let searchStr = {
        filters: [[{
          alias: '10',
          compt: "autonumber",
          express: '===',
          id: 10,
          range: null,
          val: this.exhibCode
        }]],
        model: 0
      };
      let data = {
        page: 1,
        limit: 100,
        deptId: this.formData.fid,
        formId: this.formData.exhibition_formId,
        searchStr: encodeURI(JSON.stringify(searchStr))
      };
      this.$api.singleadvanceSearch(data).then(res => {
        let list = this.setDatas(res.dataList, 'banner');
        this.detail = list[0];
        if (!this.detail.exhibName) return;
        document.title = this.detail.exhibName;
        this.exhibName = this.detail.exhibName;
        this.getChildExhibitions();
      });
    },
    getChildExhibitions() {
      let searchStr = {
        filters: [[{
          alias: '12',
          compt: "editinput",
          express: '===',
          id: 12,
          range: null,
          val: this.exhibName
        }]],
        model: 0
      };
      let data = {
        page: 1,
        limit: 50,
        deptId: this.formData.fid,
        formId: this.formData.exhibition_formId,
        searchStr: encodeURI(JSON.stringify(searchStr)),
        orderBy: 'manualOrder',
        orderType: 'desc'
      };
      this.$api.singleadvanceSearch(data).then(res => {
        let list = this.setDatas(res.dataList, 'list');
        this.childExhibitions = list;
        console.log(this.childExhibitions, 111);
      });
    },
    toggleFold() {
      this.isFolded = !this.isFolded;
    },
    setDatas(data, type) {
      return data.map(item => {
        return {
          exhibName: this.getFormData(item, 'name', 'val'),
          price: this.getFormData(item, 'expend', 'val'),
          exhibType: this.getFormData(item, 'type', 'val'),
          images: this.getFormData(item, 'image', 'fileUrl'),
          exhibitionLocation: this.getFormData(item, 'address', 'val'),
          exhibBegin: this.getFormData(item, 'startTime', 'val'),
          exhibEnd: this.getFormData(item, 'endTime', 'val'),
          description: this.getFormData(item, 'description', 'val'),
          en_name: this.getFormData(item, 'en_name', 'val'),
          en_location: this.getFormData(item, 'en_location', 'val'),
          en_desc: this.getFormData(item, 'en_desc', 'val'),
          desc: this.getFormData(item, 14, 'val'),
          code: this.getFormData(item, 10, 'val'),
          en_brfDesc: this.getFormData(item, 'en_brfDesc', 'val')
        };
      });
    },
    getFormData(data, Tkey, key) {
      data = data.formIdValueData;
      if (!data[Tkey]) return '';
      let target = data[Tkey].groupValues[0];
      if (!target) return '';
      return target.values.length && target.values[0] ? target.values[0][0] ? target.values[0][0][key] : '' : '';
    }
  },
  created() {
    flexible();
    let query = this.$route.query;
    this.formData = {
      exhibition_formId: 171924,
      audio_formId: 171925,
      fid: query.fid
    };
    this.exhibCode = query.exhibCode;
    this.language = this.$route.query.language;
    this.getIdDetail();
  },
  computed: {}
};